export default __webpack_public_path__ + "static/media/pixel2xl.a720272f.png";